export default "__VITE_ASSET__DrrLhlT9__"